import { Flex, Stack, Tabs } from '@mantine/core';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { UserStatus } from '@prisma/client';
import { FeatureFlag } from '@web/common';
import { BMSSample } from '../BMSSample';
import { BdmRetrievalsSection } from '../Nachversand';
import { QuestionnaireStatusSection } from '../QuestionnaireStatus';
import { UserStatusButtons } from '../../userStatus';
import { OpenOrdersForUser } from '../../../view/authenticated/organizer/open-shop-orders/OpenOrdersForUser';
import { isFeatureEnabled } from '../../../util/ff/isFeatureEnabled';

type ActiveParticipantTabsProps = {
  currentStatus: UserStatus;
  onUserStateUpdated: () => void;
};

export const ActiveParticipantTabs = observer(
  ({ currentStatus, onUserStateUpdated }: ActiveParticipantTabsProps) => {
    const { t } = useTranslation('nachversand');
    const shopEnabled = isFeatureEnabled(FeatureFlag.Shop);

    return (
      <Tabs defaultValue="information" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="information">{t('Panel.Tabs.Information')}</Tabs.Tab>
          {shopEnabled && (
            <Tabs.Tab value="orders">{t('Panel.Tabs.Orders')}</Tabs.Tab>
          )}
          <Tabs.Tab value="questionnaires">
            {t('Panel.Tabs.Questionnaires')}
          </Tabs.Tab>
          <Tabs.Tab value="studie">{t('Panel.Tabs.Studie')}</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="information" pt="16px">
          <Stack gap="10px">
            <BMSSample />
          </Stack>
          {/* Teilnehmer-Lifecycle-Aktionen leben nur im Information-Tab (nicht in
              den Studien-Tabs); für nicht-aktive Teilnehmer stehen sie standalone
              in ParticipantDetailUI. */}
          <Flex mt="24px">
            <UserStatusButtons
              currentStatus={currentStatus}
              onUserStateUpdated={onUserStateUpdated}
            />
          </Flex>
        </Tabs.Panel>

        {shopEnabled && (
          <Tabs.Panel value="orders" pt="16px">
            <OpenOrdersForUser />
          </Tabs.Panel>
        )}

        <Tabs.Panel value="questionnaires" pt="16px" mb="24px">
          <QuestionnaireStatusSection />
        </Tabs.Panel>

        {/* Die untere Abschlusslinie sitzt in BdmRetrievalsSection: sie gehört zum
            Inhalt und darf unter einem leeren Panel nicht erscheinen. */}
        <Tabs.Panel value="studie" pt="16px" mb="24px">
          <BdmRetrievalsSection />
        </Tabs.Panel>
      </Tabs>
    );
  },
);
